import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'abbreviateOrgName',
	pure: true,
	standalone: true
})
export class AbbreviateOrgNamePipe implements PipeTransform {
	public transform (name: string | null | undefined, maxLetters = 3): string {
		if (name == null) {
			return '';
		}

		const trimmed = name.trim().replace(/\s+/g, ' ');

		// Capitals at word starts (Unicode letters)
		const capsAtWordStart = [...trimmed.matchAll(/(?:^|[^\p{L}])(\p{Lu})/gu)]
			.map((match: RegExpMatchArray) => match[1])
			.slice(0, maxLetters);

		if (capsAtWordStart.length) {
			return capsAtWordStart.join('');
		}

		const words = trimmed.match(/\p{L}+/gu) ?? [];
		return words.slice(0, maxLetters)
			.map((word: string) => word[0].toUpperCase())
			.join('');
	}
}
